var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAdd64(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 284"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line 7",
    x1: 32.5,
    y1: -2.18557e-8,
    x2: 32.5,
    y2: 64,
    stroke: "#0A101A"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 8",
    x1: 64,
    y1: 32.5,
    x2: -4.37114e-8,
    y2: 32.5,
    stroke: "#0A101A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd64);
export default __webpack_public_path__ + "static/media/icon-add-64.0292395c3179393d3904230cae11a49d12b99a539bc9d82de1e28f8807d2e7e4.svg";
export { ForwardRef as ReactComponent };